export enum FeatureFlag {
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  WEB_SCHEDULING_ABANDONED_FLOW_ENABLED = "WEB_SCHEDULING_ABANDONED_FLOW_ENABLED",
}
